import { ButtonColor } from "@/common/enum/button-color";
import { PageWrapper } from "@/components/wrapper/PageWrapper";
import { Button } from "flowbite-react";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { profileState } from "../../atoms/user/profile-state";
import { PartnerMyProfileHeader } from "../../components/header/PartnerMyProfileHeader";
import { PartnerAddressModal } from "../../components/modal/PartnerAddressModal";
import { PartnerPasswordModal } from "../../components/modal/PartnerPasswordModal";
import { PartnerPhoneModal } from "../../components/modal/PartnerPhoneModal";
import { PartnerMyDetailTable } from "../../components/table/partner-my-detail-table/PartnerMyDetailTable";

export default function PartnerMyProfilePage() {
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [openAddressModal, setOpenAddressModal] = useState(false);
  const [openPhoneModal, setOpenPhoneModal] = useState(false);
  const [profile, setProfile] = useRecoilState(profileState);

  const modalOpenPhoneModal = () => {
    setOpenPhoneModal(true);
  };

  const modalClose = () => {
    setOpenPhoneModal(false);
    setOpenPasswordModal(false);
    setOpenAddressModal(false);
  };

  const modalOpenAddressModal = () => {
    setOpenAddressModal(true);
  };

  const modalOpenPasswordModal = () => {
    setOpenPasswordModal(true);
  };

  return (
    <PageWrapper>
      <div className="flex flex-col w-[1392px] h-full items-between justify-start gap-[16px]">
        <PartnerMyProfileHeader />
        {profile && (
          <PartnerMyDetailTable
            user={profile}
            handlePhoneModalOpen={modalOpenPhoneModal}
            handleAddressModalOpen={modalOpenAddressModal}
            // departmentId={inputs.departmentId}
            // handlePhoneChange={handlePhoneChange}
            // handleDepartmentChange={handleDepartmentChange}
          />
        )}
        <div className="pt-[8px]">
          <Button
            color={ButtonColor.TRANSPARENT_OUTLINE}
            onClick={modalOpenPasswordModal}
          >
            비밀번호 변경하기
          </Button>
        </div>
      </div>
      {profile && openPasswordModal && (
        <PartnerPasswordModal user={profile} closeModal={modalClose} />
      )}
      {profile && openPhoneModal && (
        <PartnerPhoneModal closeModal={modalClose} />
      )}
      {profile && openAddressModal && (
        <PartnerAddressModal closeModal={modalClose} />
      )}
    </PageWrapper>
  );
}
